(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // Group the "sort by" control and the grid/list view toggle into a single
  // bordered pill, since they render as two separate, unstyled siblings by
  // default.
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.facets__form').forEach((form) => {
      const sorting = form.querySelector('.sorting-filter.sorting-filter__horizontal');
      const columnOptions = form.querySelector('.column-options-wrapper');
      if (!sorting || !columnOptions || sorting.closest('.sort-view-group')) return;
      const group = document.createElement('div');
      group.className = 'sort-view-group';
      sorting.parentNode.insertBefore(group, sorting);
      group.appendChild(sorting);
      group.appendChild(columnOptions);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
